<template>
<div>
    <div class="container mt-5">
        <div class="row justify-content-md-center">
            <div class="col-md-5">
                <p class="is-size-3">
                    Handbuch
                </p>
                <a href="/static/handleiding/Handleiding_WEB.pdf">
                    <img class="img-fluid shadow-lg" src="/static/handleiding/Handleiding_WEB.png" />
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top from './Top.vue'

export default {
    components: {
        top,
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
